import { Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { headerCellStyle, tableInRowStyle, orderCellStyles, stockCellStyles, supplyCellStyles, supplyProductStyles } from "./supplyTableStyles";

function SupplyTableHeaderRow({suppliers}) {

  return (
    <TableRow>
      <TableCell sx={{...headerCellStyle, ...supplyProductStyles.dragHandle}}></TableCell>
      <TableCell sx={{...headerCellStyle, ...supplyProductStyles.hideButton}}></TableCell>
      <TableCell sx={headerCellStyle}>品名</TableCell>
      <TableCell sx={headerCellStyle}>産地</TableCell>
      <TableCell sx={headerCellStyle}>規格</TableCell>
      <TableCell sx={headerCellStyle}>発注単位</TableCell>
      {/*<TableCell sx={headerCellStyle}>*/}
      {/*  <Table>*/}
      {/*    <TableBody>*/}
      {/*      <TableRow sx={tableInRowStyle}>*/}
      {/*        <TableCell sx={headerCellStyle}>受注</TableCell>*/}
      {/*      </TableRow>*/}
      {/*      <TableRow  sx={tableInRowStyle}>*/}
      {/*        <TableCell sx={headerCellStyle}>*/}
      {/*          <Grid container spacing={1}>*/}
      {/*            <Grid item sx={orderCellStyles.unitQuantity}>入数</Grid>*/}
      {/*            <Grid item sx={orderCellStyles.orderAmount}>数量</Grid>*/}
      {/*          </Grid>*/}
      {/*        </TableCell>                  */}
      {/*      </TableRow>*/}
      {/*    </TableBody>*/}
      {/*  </Table>*/}
      {/*</TableCell>*/}
      {/*<TableCell sx={headerCellStyle}>発注数量計</TableCell>*/}
      {
        suppliers.map((supplier) => (
          <TableCell sx={{...headerCellStyle, ...supplyCellStyles.leftBorder}} key={supplier.commodityOwnerCd}>
            <Table>
              <TableBody>
                <TableRow sx={tableInRowStyle}>
                  <TableCell sx={headerCellStyle}>{supplier.commodityOwnerName}</TableCell>
                </TableRow>
                <TableRow  sx={tableInRowStyle}>
                  <TableCell sx={headerCellStyle}>
                    <Grid container spacing={1}>
                      <Grid item sx={supplyCellStyles.validUnitQuantityCheck}>入数</Grid>
                      <Grid item sx={{width: 150}}>発注数量</Grid>
                      <Grid item>備考</Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableCell>
        ))
      }
    </TableRow>
  )
}

export default SupplyTableHeaderRow;